'use client';

import type { Blog } from '@eliadmin/core/src/api/blogs/blogs-types';

import { Button } from '../ui/button';
import { FaFacebook } from 'react-icons/fa';

import { RiLinksFill } from 'react-icons/ri';
import { toast } from '@eliadmin/core/src/components/ui/use-toast';
import { Heading } from '../ui/heading';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function BlogShare({ blog }: { blog: Blog }) {
  const { t } = useTranslations();

  const handleCopyLink = () => {
    if (typeof window === 'undefined') return;

    const baseUrl =
      (blog as any)?.canonical_url ||
      (blog as any)?.url ||
      `${window.location.origin}/blog/${blog.slug}`;

    try {
      navigator.clipboard.writeText(baseUrl);
      toast({
        title: t('text3835'),
        variant: 'success',
      });
    } catch (err) {
      toast({
        title: t('text4070'),
        variant: 'destructive',
      });
    }
  };

  const handleShare = () => {
    if (typeof window === 'undefined') return;

    const baseUrl =
      (blog as any)?.canonical_url ||
      (blog as any)?.url ||
      `${window.location.origin}/blog/${blog.slug}`;

    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(baseUrl)}`;

    window.open(shareUrl, '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  return (
    <div className="flex w-full max-w-[926px] flex-col items-start justify-start gap-2">
      <Heading title={t('text1155')} tag="h6" center className={{ title: 'text-[#666666]' }} />
      <div className="flex w-full items-start justify-start gap-2">
        <Button variant={'white'} size={'icon'} onClick={handleCopyLink}>
          <RiLinksFill size={20} className="text-foreground" />
        </Button>
        <Button variant={'white'} size={'icon'} onClick={handleShare}>
          <FaFacebook size={20} className="text-foreground" />
        </Button>
      </div>
    </div>
  );
}
